import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface MessagesState {
  map: Record<string, string>;
  loaded: boolean;
}

const initialState: MessagesState = {
  map: {},
  loaded: false,
};

const messagesSlice = createSlice({
  name: "messages",
  initialState,
  reducers: {
    setConfigurableMessages: (state, action: PayloadAction<Record<string, string>>) => {
      state.map = action.payload || {};
      state.loaded = true;
    },
  },
});

export const { setConfigurableMessages } = messagesSlice.actions;
export default messagesSlice.reducer;
